import PaginationModel from "@/models/paginationModel";
import nfetch from "@/utils/events/nfetch";

import GrupoProdutoModel from "../../models/produto/grupoProdutoModel";
import { GrupoProdutoOption } from "../../types/options";
import { iServiceCached } from "../base/iServiceCached";

function mapCombo(dados: GrupoProdutoModel[]): GrupoProdutoOption[] {
    return dados.map(p => ({
        value: p.id!,
        text: p.descricao,
        tipo: p.tipoProduto,
    }));
}

class GrupoProdutoService extends iServiceCached<GrupoProdutoModel> {
    private cachedByFranquia: { [franquiaId: number]: GrupoProdutoModel[] } = {};

    constructor() {
        super("GrupoProduto");
    }

    public async comboCached(franquiaId: number): Promise<GrupoProdutoOption[]> {
        const retorno = await this.combo(franquiaId);
        return mapCombo(retorno);
    }

    public async comboCachedByFranquiaId(franquiaId: number): Promise<GrupoProdutoOption[]> {
        if (this.cachedByFranquia[franquiaId]) {
            return mapCombo(this.cachedByFranquia[franquiaId]);
        }

        const response = await nfetch(`/${this.controllerName}/List?franquiaId=${franquiaId}`, {
            credentials: "same-origin",
        })
            .withLoading()
            .resolveWithJSON<PaginationModel<GrupoProdutoModel>>();

        this.cachedByFranquia[franquiaId] = response.list;

        return mapCombo(response.list);
    }
}

export default new GrupoProdutoService();
